<script setup>
import { computed } from 'vue'

const props = defineProps({
  text: {
    type: String,
    required: true
  },
  position: {
    type: String,
    default: 'bottom'
  }
})

const tooltipClasses = computed(() => {
  return {
    'tooltip__text': true,
    [`tooltip--${props.position}`]: true
  }
})
</script>

<template>
  <div class="tooltip-wrapper">
    <slot />
    <span :class="tooltipClasses">{{ text }}</span>
  </div>
</template>